import { Routes } from '@angular/router';

export const DEACTIVATED_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('../ui/auth-deactivated-message/auth-deactivated-message.component').then((c) => c.AuthDeactivatedMessageComponent),
  },
];
